import { render, staticRenderFns } from "./videoPlayerModal.vue?vue&type=template&id=411fa061"
import script from "./videoPlayerModal.vue?vue&type=script&lang=js"
export * from "./videoPlayerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411fa061')) {
      api.createRecord('411fa061', component.options)
    } else {
      api.reload('411fa061', component.options)
    }
    module.hot.accept("./videoPlayerModal.vue?vue&type=template&id=411fa061", function () {
      api.rerender('411fa061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/videoPlayerModal.vue"
export default component.exports